import React from 'react';
import { roles } from '@nxsys/store/constants';
import PaymentRateListing from '../../../modules/paymentSetting/listing/PaymentRateListing';

const ComingSoon = React.lazy(
  () => import('../../../modules/errorPages/ComingSoon'),
);

export const paymentRatesConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/payment-rates',
    element: <PaymentRateListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/payment-rates/create',
    element: <ComingSoon />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/payment-rates/:paymentRateId',
    element: <ComingSoon />,
  },
];
